import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  escuela: null,
  plantel: null,
};

const dashboardFiltersSlice = createSlice({
  name: "dashboardFilters",
  initialState,
  reducers: {
    setEscuela: (state, action) => {
      state.escuela = action.payload;
      // cuando cambia la escuela, limpiar plantel
      state.plantel = null;
    },
    setPlantel: (state, action) => {
      state.plantel = action.payload;
    },
    clearFilters: (state) => {
      state.escuela = null;
      state.plantel = null;
    },
  },
});

export const { setEscuela, setPlantel, clearFilters } = dashboardFiltersSlice.actions;
export default dashboardFiltersSlice.reducer;
